const UserInvitationStep = {
  LOADING_SCREEN: 1,
  ERROR_INVALID_TOKEN: 2,
  REGISTER_FORM_SCREEN: 3,
  CONFIRMATION_MSG_SCREEN: 4,
  ERROR_MSG_SCREEN: 5,
};
export default UserInvitationStep;
